export default __webpack_public_path__ + "static/media/icon_hamburguer.cc567485.svg";